<template>
	<v-dialog v-model="isVisible" max-width="600">
		<p-card class="tw-p-none evaluation-select-question-dialog overflow-hidden">
			<p-header-dialog :negative-margin="false" @closeClicked="close()">
				Agregar Pregunta
			</p-header-dialog>
			<ul
				class="evaluation-select-question-dialog--list tw-text-app-color-font"
				v-if="!!availableQuestions.length"
			>
				<li
					v-for="(question, index) in availableQuestions"
					class="tw-flex tw-justify-between tw-items-center tw-gap-4 tw-px-4 tw-py-2"
				>
					<span class="tw-inline-block">{{ index + 1 }}.</span>
					<div class="tw-flex-1">
						{{ propOr('-', questionsType.key, question) }}
					</div>
					<p-button
						size="small"
						type="primary"
						:outlined="true"
						@click="handleQuestionSelection(question)"
						>Seleccionar</p-button
					>
				</li>
			</ul>
			<p-empty-message style="height: 50vh" v-if="!availableQuestions.length">
				No hay preguntas disponibles
			</p-empty-message>
		</p-card>
	</v-dialog>
</template>
<script>
import { find, filter, propEq, propOr } from 'ramda';
import PCard from '../../../../shared/components/ui/Card/p-card';
import CloseIcon from '../../../../shared/components/icons/close-icon';
import PButton from '../../../../shared/components/ui/p-button';
import PHeaderDialog from '../../../../shared/components/ui/dialog/p-header-dialog';
import PEmptyMessage from '../../../../shared/components/ui/p-empty-message';

export default {
	components: { PEmptyMessage, PHeaderDialog, PButton, CloseIcon, PCard },
	name: 'evaluation-select-question-dialog',
	props: ['questions', 'selectedQuestions', 'questionsType'],
	data() {
		return {
			isVisible: false,
		};
	},
	methods: {
		propOr,
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
		handleQuestionSelection(selectedQuestion) {
			this.$emit('onQuestionSelected', selectedQuestion);
			this.close();
		},
	},
	computed: {
		availableQuestions() {
			return filter(
				question => !find(propEq('id', question.id), this.selectedQuestions), // filtering not selected questions
				this.questions,
			);
		},
	},
};
</script>

<style lang="scss" scoped>
.evaluation-select-question-dialog {
	&--list {
		padding: 0;
		height: 50vh;
		overflow: auto;
		li {
			border-bottom: 1px solid var(--app-color-gray);
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/third-step/components/evaluation-select-question-dialog.vue